import axios from 'axios';

export interface MoreProps {
  [index: string]: string;
}

export interface RadioINProps {
  id: number;
  radio_id: string | number;
  name: string;
  thumb: string;
  radio_url: string;
  categories: string;
  streams: string;
  more: MoreProps;
  radio_group: string;
  type: string;
  radio_img: string;
  radio_img_thumb: string;
  country_code: string;
}

export interface RadioProps {
  id: number;
  radio_id: string | number;
  name: string;
  thumb: string;
  radio_url: string;
  categories: string;
  streams: string[];
  more: MoreProps;
  radio_group: string;
  type: string;
  radio_img: string;
  radio_img_thumb: string;
  country_code: string;
}

export interface Country {
  name: string;
  code: string;
}

export const availableCountries: Country[] = [
  {
    name: 'United Kingdom',
    code: 'gb',
  },
  {
    name: 'Nederland',
    code: 'nl',
  },
  {
    name: 'Danmark',
    code: 'dk',
  },
  {
    name: 'Česká republika',
    code:  'cz',
  },
  {
    name: 'België',
    code: 'be',
  },
  {
    name: 'France',
    code: 'fr',
  },
  {
    name: 'Portugal',
    code: 'pt',
  },
  {
    name: 'Deutschland',
    code: 'de',
  },
  {
    name: 'Polska',
    code: 'pl',
  },
  {
    name: 'España',
    code: 'es',
  },
  {
    name: 'México',
    code: 'mx',
  },
  {
    name: 'भारत',
    code: 'in',
  },
  {
    name: 'Italia',
    code: 'it',
  },
  {
    name: 'Argentina',
    code: 'ar',
  },
  {
    name: 'Brasil',
    code: 'br',
  },
  {
    name: 'Columbia',
    code: 'co',
  },
];

const getRadiolist = async (country: string, category = 0): Promise<RadioINProps[]> => {
  const url = 'http://137.74.92.81:8081/getAllLists2/' + country + '/'+ category;
  const data = await axios.get(url);
  return data.data.allStreams;
};

export interface ICategory {
  id: number;
  name: string;
  lang: string;
}

export const getCategories = async (country: string): Promise<ICategory[]> => {
  const url = 'http://137.74.92.81:8081/getAllCategories/' + country;
  const data = await axios.get(url);
  return data.data.categories;
};

export const getAllRadios = async (country: string, category = 0): Promise<RadioProps[]> => {
  // const rmfLives = await getRMFLiveInfo();
  const allStreams = await getRadiolist(country, category);
  const output: RadioProps[] = [];

  for (const item of allStreams) {
    const out = item;

    if (item.radio_img) {
      out.thumb = item.radio_img;
    }

    output.push({
      id: out.id,
      radio_id: out.radio_id,
      name: out.name,
      thumb: out.thumb,
      radio_url: out.radio_url,
      categories: out.categories,
      streams: JSON.parse(out.streams),
      more: out.more,
      radio_group: out.radio_group,
      type: out.type,
      radio_img: out.radio_img,
      radio_img_thumb: out.radio_img_thumb,
      country_code: out.country_code,
    });
  }

  return output;
};
